const preScanNL = {
    "form": {
        "modal": {
            "preScanResults": {
                "header": "Pre-Scan Resultaten",
                "body": {
                    "description": "De volgende resultaten zijn gevonden na het uitvoeren van een scan voor deze release. Controleer deze in detail:",
                    "table": {
                        "column": {
                            "trackName": "Track Naam",
                            "type": "Type",
                            "title": "Titel",
                            "artists": "Artiesten",
                            "album": "Album",
                            "label": "Uitgever",
                            "releaseDate": "Releasedatum",
                            "score": "Waardering (%)"
                        },
                    },
                    "label": {
                        "flaggedTracks": "Gemarkeerde Tracks",
                        "music": "Muziek",
                        "cover": "Omslag",
                        "signDeclaration": "Onderteken de verklaring om verder te gaan.",
                        "cancelRelease": "Ik wil deze release annuleren.",
                        "approveRelease": {
                            "point1": "Ik wil deze release goedkeuren omdat de resultaten 100% identiek zijn aan mijn eigen release / overdracht van de vorige uitgever.",
                            "point2": "Ik verklaar hierbij onder gewetenheidsbelasting, dat alle inhoud die ik lever, eigendom is van mijn bedrijf of van mij, of dat ik volledige en geldige rechten en licenties bezit, die nodig zijn voor het gebruik, de distributie en de indiening.",
                            "point3": "Ik erkenn en accepteer dat ik volledig verantwoordelijk ben voor alle juridische gevolgen die kunnen ontstaan uit de indiening van dergelijke inhoud, inclusief maar niet beperkt tot juridische procedures, claims, kosten en kosten.",
                            "point4": "Ik begrijp en ga akkoord dat mijn persoonlijke gegevens, inclusief KYC-gegevens en andere relevante gegevens, gedeeld kunnen worden met geautoriseerde partners, digitale serviceproviders (DSPs), derde partijen die betrokken zijn bij de verwerking van dergelijke inhoud, alsmede rechtbanken, bevoegde autoriteiten en rechtshandhavingseenheden in het geval van een claim, geschil of juridische vereiste.",
                            "point5": "Ik begrijp en ga akkoord dat Music Link het recht heeft om mijn overeenkomst onmiddellijk te beëindigen, zonder enige compensatie of aanvullende verplichting, als is aangetoond dat ik dit formulier misbruikt heb of als een deel van mijn verklaring onjuist, misleidend of onjuist wordt vertegenwoordigd.",
                        },
                        "noFlaggedTracks": "Geen gemarkeerde tracks gedetecteerd in de pre-scan, je kunt verdergaan met de volgende stappen!"
                    },
                    "help_text": {
                    },
                },
                "button": {
                    "submit": "Indienen",
                    "close": "Sluiten"
                }
            },
            "performScan": {
                "header": "Uitvoeren Pre-Scan",
                "body": "Bevestig dat je de pre-scan wilt uitvoeren voor deze release.",
                "button": {
                    "cancel": "Annuleren",
                    "performScan": "Uitvoeren Scan"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "Je hebt de distributie van de release geannuleerd, daarom is deze verwijderd.",
            "admin_pending": "Je verklaring is in behandeling bij de admin voor verdere actie.",
            "admin_approved": "Je aanvraag om de release te distribueren is goedgekeurd door onze admin team. De release is succesvol geverifieerd. We appreciëren je inzet om nauwkeurigheid en conformiteit te garanderen. De release zal verdergaan naar alle winkels zoals gepland. Bedankt voor je aandacht aan detail en volgorde van onze standaarden.",
            "admin_rejected": "Je aanvraag om de release te distribueren is afgewezen. Na een zorgvuldige beoordeling voldoet de aanvraag niet aan onze goedkeuringsvereisten. We raden aan om de inhoud opnieuw te evalueren en ervoor te zorgen dat aan alle voorwaarden en juridische implicaties is voldaan. Bedankt voor je begrip en medewerking.",
            "scanInProgress": "Scan in behandeling, wacht tot de scan is voltooid.",
            "releaseMustBeReady": "Release moet in status Ready staan om de pre-scan uit te voeren.",
            "errorSubmittingDeclaration": "Er is een fout opgetreden bij het indienen van de verklaring van de admin voor de pre-scan.",
        }
    }
};

export default preScanNL;